module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "pt01"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "pa01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('h2', {
    staticClass: "partTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Ambulance Ship")]), _vm._v(" "), _c('div', {
    staticClass: "partEpigraph"
  }, [_c('p', {
    staticClass: "partEpigraphText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("O")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACK")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHEN")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WHO IS A STICKLER FOR XENOBIOLOGICAL VERISIMILITUDE,")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IN APPRECIATION")])])])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('div', {
    staticClass: "partBody"
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a794c17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312877705_pt01.vue
// module id = 75
// module chunks = 0